import { Close } from "@mui/icons-material";
import { Dialog, DialogTitle, IconButton, Typography } from "@mui/material";

interface Props {
  text: string;
  imgSrc: string;
  onClose: () => void;
}

export default function ImageModal(props: Props) {
  const { text, imgSrc, onClose } = props;
  return (
    <Dialog open onClose={onClose}>
      <DialogTitle className="bg-primary flex items-center text-white">
        <IconButton
          edge="start"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <Close />
        </IconButton>
        <Typography variant="h6">Galeria de Imagem</Typography>
      </DialogTitle>

      <img src={imgSrc} alt={text || "Foto da avaliação"} width={800} height={600} />
    </Dialog>
  );
}
